import React, { useState } from 'react'
import { Col, Row } from 'antd'
import styles from './style.module.scss'

const Categories = ({ dispatch, categoryList }) => {
  const [selected, setSelected] = useState()

  const onCategorySelected = (categoryName, id) => {
    const payload = {
      page: 1,
      limit: 10,
    }

    // we set the selected category based on the id
    if (selected === id) {
      setSelected()
    } else {
      setSelected(id)
      payload.category = categoryName
    }

    dispatch({
      type: 'files/LOAD_FILES',
      payload,
    })
  }

  const CategoryIcon = (name = 'default', id, logo = 'lnr-cloud-sync') => {
    const isCategorySelected = id === selected ? 'selected' : 'unselected'
    return (
      <Col onClick={() => onCategorySelected(name, id)}>
        <div className={`${styles[`iconShape_${isCategorySelected}`]}`}>
          <Row>
            <i className={`${styles[`categoryIcon_${isCategorySelected}`]} lnr ${logo}`} />
          </Row>
          <div className={styles[`iconText_${isCategorySelected}`]}>{name}</div>
        </div>
      </Col>
    )
  }
  // TODO
  /**
   * Use icons folder in order to let the user the possibility to change the logo of the category
   * Then apply the background when the user select one or another of the categories listed
   */
  return (
    <Row className="mb-5 mt-3" gutter={20}>
      {categoryList.map(category => {
        const { name, _id, logo } = category
        console.log('_id ', _id)
        return CategoryIcon(name, _id, logo)
      })}
    </Row>
  )
}

export default Categories // connect()(EcommerceProductCatalog)
